module.exports = __webpack_public_path__ + "static/media/drop-20@2x.7423fbfd.png";